import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
const chapters = [{
  num: 1,
  title: 'La Verdad Oculta',
  desc: <>
        Por qué realmente perdés el control (no es lo que pensás) y cómo los
        maestros taoístas lo solucionaron hace{' '}
        <strong className="text-white" data-id="element-183">
          siglos para reyes antiguos con muchas mujeres.
        </strong>
      </>
}, {
  num: 2,
  title: 'Los 3 Niveles de Dominio Sexual',
  desc: <>
        El sistema completo que usan los hombres que tienen{' '}
        <strong className="text-brand-gold" data-id="element-184">control total</strong> sobre su
        cuerpo
      </>
}, {
  num: 3,
  title: 'Respiración de Poder',
  desc: <>
        La técnica taoísta específica que te da control absoluto del orgasmo en{' '}
        <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-185">
          tiempo real
        </span>
      </>
}, {
  num: 4,
  title: 'El Método de las Ondas',
  desc: <>
        Cómo surfear la excitación y mantenerla en el{' '}
        <strong className="text-white" data-id="element-186">nivel exacto que vos querés</strong>
      </>
}, {
  num: 5,
  title: 'Reprogramación Mental',
  desc: <>
        Cómo usar tu mente para{' '}
        <strong className="text-brand-red" data-id="element-187">dominar completamente</strong> las
        respuestas de tu cuerpo
      </>
}, {
  num: 6,
  title: 'Los 5 Ejercicios Diarios',
  desc: <>
        La rutina de{' '}
        <span className="bg-brand-gold/10 px-1 rounded text-brand-gold" data-id="element-188">
          15 minutos
        </span>{' '}
        de Ejercicios Kegel Clave que fortalecen tu control sexual para toda la
        vida
      </>
}, {
  num: 7,
  title: 'Protocolo Día por Día',
  desc: <>
        Qué hacer exactamente cada día durante los primeros 7 días para{' '}
        <strong className="text-white" data-id="element-189">resultados garantizados</strong>
      </>
}, {
  num: 8,
  title: 'Técnicas Avanzadas',
  desc: <>
        Para sesiones de{' '}
        <span className="bg-brand-gold/10 px-1 rounded text-brand-gold" data-id="element-190">
          30+ minutos
        </span>{' '}
        y control de nivel maestro
      </>
}];
const stats = [<>
    <span className="bg-brand-gold/10 px-1 rounded text-brand-gold font-bold" data-id="element-191">
      92%
    </span>{' '}
    de efectividad comprobada en 7 días
  </>, <>
    Método <strong className="text-white" data-id="element-192">100% natural</strong> - Sin químicos
    ni efectos secundarios
  </>, <>
    Basado en sabiduría ancestral de{' '}
    <span className="bg-brand-gold/10 px-1 rounded text-brand-gold font-bold" data-id="element-193">
      Reyes Antiguos con Multiples Mujeres
    </span>
  </>];
export function ProductPresentation() {
  return <section className="py-16 px-4 bg-[#0a0a0a] relative overflow-hidden" data-id="element-194">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-brand-red/5 rounded-full blur-[150px] -z-10 pointer-events-none" data-id="element-195" />

      <div className="max-w-5xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-197">
          <span className="text-6xl mb-6 block" data-id="element-198">📚</span>

          <h2 className="text-5xl md:text-7xl font-oswald font-bold text-white mb-6 tracking-tight" data-id="element-199">
            "PNM: CONTROL TOTAL"
          </h2>
          <p className="text-2xl text-gray-400 font-light" data-id="element-200">
            El método ancestral que te da control desde los primeros 7 días
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-12 items-start mb-12" data-id="element-201">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-5 sticky top-8" data-id="element-202">
            <div className="w-full aspect-[3/4] rounded-2xl shadow-2xl overflow-hidden" data-id="element-203">
              <img src="https://cdn.magicpatterns.com/uploads/gBGnXHg3hhmeUcDdBFfYkY/c0c72188-644d-4693-9874-6a2ee1b6412f.jpg" alt="PNM: Control Total - Portada del libro" className="w-full h-full object-cover" data-id="element-204" />
            </div>
          </motion.div>

          <div className="lg:col-span-7" data-id="element-205">
            <h3 className="text-3xl font-bold mb-8" data-id="element-206">
              ¿Qué vas a descubrir en este libro?
            </h3>
            <div className="space-y-6" data-id="element-207">
              {chapters.map((chapter, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="flex gap-4 p-4 rounded-xl hover:bg-brand-card/50 transition-colors" data-id="element-208">
                  <span className="text-2xl shrink-0 mt-1" data-id="element-209">📖</span>
                  <div data-id="element-210">
                    <h4 className="text-xl font-bold text-white mb-2" data-id="element-211">
                      <span className="text-brand-gold mr-2" data-id="element-212">
                        Capítulo {chapter.num}:
                      </span>
                      {chapter.title}
                    </h4>
                    <p className="text-gray-400 leading-relaxed" data-id="element-213">
                      {chapter.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-214">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-card border border-gray-800 p-6 rounded-xl flex items-center gap-4" data-id="element-215">
              <CheckCircle2 className="w-8 h-8 text-green-500 shrink-0" data-id="element-216" />
              <p className="text-white font-medium text-lg" data-id="element-217">{stat}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-218">
          <Button data-id="element-219">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}